module.exports = __webpack_public_path__ + "img/loading.0fd71154.gif";